var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Model } from "../base/Model";
export class CatalogModel extends Model {
    constructor(data, events) {
        var _a, _b;
        super(data, events);
        this.products = [];
        this.selectedProduct = null;
        this.products = (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [];
        this.selectedProduct = (_b = data === null || data === void 0 ? void 0 : data.selectedProduct) !== null && _b !== void 0 ? _b : null;
    }
    getProducts() {
        return this.products.map((product) => {
            const { description } = product, rest = __rest(product, ["description"]);
            return rest;
        });
    }
    setProducts(products) {
        this.products = products.map(p => (Object.assign({}, p)));
        this.emitChanges('catalog:products:updated', { products: this.getProducts() });
    }
    getSelectedProduct() {
        var _a;
        if (!this.selectedProduct)
            return null;
        const found = (_a = this.products.find((p) => p.id === this.selectedProduct)) !== null && _a !== void 0 ? _a : null;
        return found;
    }
    setSelectedProduct(id) {
        this.selectedProduct = id;
        const product = this.getSelectedProduct();
        this.emitChanges('catalog:selected:changed', { id, product });
    }
}
